export default __webpack_public_path__ + "static/media/partners9.6a5157c3.png";